import { Group, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

type PlayBrandProps = {
	size?: "sm" | "md" | "lg" | "xl";
	/** Wordmark next to the mark. Header uses Admin. Ignored when markOnly. */
	label?: string;
	/** Login and other places that should show the circular mark alone. */
	markOnly?: boolean;
};

const FONT_SIZE = { sm: 16, md: 18, lg: 28, xl: 28 } as const;
const MARK_SIZE = { sm: 32, md: 36, lg: 48, xl: 96 } as const;

export function PlayBrand({
	size = "md",
	label,
	markOnly = false,
}: PlayBrandProps) {
	const { t } = useTranslation();
	const mark = MARK_SIZE[size];
	const word = label ?? t("app.brand");

	return (
		<Group gap={8} wrap="nowrap" align="center">
			<img
				src="/logo.png"
				alt={markOnly ? word : ""}
				width={mark}
				height={mark}
				style={{ display: "block", borderRadius: "50%", flexShrink: 0 }}
			/>
			{markOnly ? null : (
				<Text
					fw={700}
					tt="uppercase"
					lts={2}
					lh={1.1}
					style={{ color: "var(--play-brand)", fontSize: FONT_SIZE[size] }}
				>
					{word}
				</Text>
			)}
		</Group>
	);
}
